// stripeConfig.js
export function getStripePublishableKey(hostname) {
  if (hostname.includes("wallet.psychiclight.com")) {
    // URL contains wallet.psychiclight.com
    return "pk_live_51R68qYIGdSz1qp3wPi2DyfDTkY9u10yxNQOeozTleMGdpEDa7prRFTh0MyMknTF5hdln18g53xUJstMloLczi7g500cBsK9BIi";
  }

  // Fallback (optional)
  return "pk_live_6egOIamIybTZWS0aOv39dEqu";
}
